import React from 'react';
import { SecondarySummaryTable } from './styled';

interface IData {
  metric: string,
  value: number | string;
  unit: string | undefined;
}

interface IProps {
  title: string;
  data: IData[];
}

const SecondaryList: React.FC<IProps> = ({
  title,
  data,
}) => {
  const rows = data.map((d) => {
    const { metric, value, unit = '' } = d;
    return (
      <tr key={metric}>
        <td>{metric}</td>
        <td className="value">{`${value} ${unit}`}</td>
      </tr>
    );
  });
  return (
    <SecondarySummaryTable>
      <thead>
        <tr><th colSpan={2}>{title}</th></tr>
      </thead>
      <tbody>
        {rows}
      </tbody>
    </SecondarySummaryTable>
  );
};

export default SecondaryList;
